const VOICE_PATH_PATTERN = /^\/v\/(?:0[1-9]|1[01])$/;
const APP_ORIGIN = "https://home-twice.invalid";

/** Accept only the landing, library, or a valid voice-page route; reject external redirects. */
export function normalizeReturnPath(candidate: string | null | undefined): string {
  if (!candidate || !candidate.startsWith("/") || candidate.startsWith("//")) {
    return "/";
  }

  try {
    const parsed = new URL(candidate, APP_ORIGIN);
    if (parsed.origin !== APP_ORIGIN) return "/";
    if (parsed.pathname === "/") return `/${parsed.search}${parsed.hash}`;
    if (parsed.pathname === "/library") return `/library${parsed.search}${parsed.hash}`;
    if (VOICE_PATH_PATTERN.test(parsed.pathname)) {
      return `${parsed.pathname}${parsed.search}${parsed.hash}`;
    }
  } catch {
    return "/";
  }

  return "/";
}

export function buildAuthCallbackUrl(
  returnPath: string | null | undefined,
  origin: string,
  attemptId?: string,
): string {
  const callback = new URL("/auth/callback", origin);
  callback.searchParams.set("next", normalizeReturnPath(returnPath));
  if (attemptId) callback.searchParams.set("attempt", attemptId);
  return callback.toString();
}
